export const RICH_CARD_CAROUSEL_MAX_IMAGES = 5
